// import Values from 'values.js';
import tinycolor from 'tinycolor2';
import { layoutDefaults } from '../layout-defaults';

function parseContainerBackgroundShade(layout, shade = 0) {
  const color = tinycolor(layout?.background?.container_color);
  return color.darken(shade).toString();

  // const container_color = new Values(layout?.background?.container_color);
  // return container_color.shade(shade).hexString();
}

// function parseContainerBackgroundShade(layout, shade = 0) {
//     let color = tinycolor(layout?.background?.container_color);
//     return color.darken(shade).toString();

//     // const container_color = new Values(layout?.background?.container_color);
//     // return container_color.shade(shade).hexString();
// }

function parseContainerBackgroundGradient(layout, { lighthenOffset = 0 } = {}) {
  let color = tinycolor(
    layout?.background?.container_color ?? layoutDefaults.primaryColor
  );

  if (lighthenOffset != null && lighthenOffset !== 0) {
    color = tinycolor(color).lighten(lighthenOffset);
  }

  return [
    color.clone().darken(5).toString(),
    color.clone().toString(),
    color.clone().toString(),
    color.clone().brighten(5).toString(),
  ];

  // const container_color = new Values(layout?.background?.container_color);

  // return [
  //     container_color.shade(15).hexString(),
  //     container_color.hexString(),
  //     container_color.tint(5).hexString(),
  // ];
}
function parseDividerBackgroundGradient(layout) {
  const color1 = tinycolor(layout?.text?.default_color);
  const color2 = tinycolor(layout?.text?.default_color);
  const color3 = tinycolor(layout?.background?.container_color);

  color1.setAlpha(0.4);
  color2.setAlpha(0.2);
  color3.setAlpha(0.3);

  return [color1.toRgbString(), color2.toRgbString(), color3.toRgbString()];

  // const text_color = new Values(layout?.text?.default_color);
  // const container_color = new Values(layout?.background?.container_color);

  // const beginColor = text_color.rgb;
  // beginColor.push(.4);

  // const endColor = container_color.rgb;
  // endColor.push(.3);

  // return [
  //     `rgba(${beginColor.join(',')})`,
  //     `rgba(${endColor.join(',')})`,
  // ];
}

function parseContainerBackgroundImage(layout, { lighthenOffset = 0 } = {}) {
  return `linear-gradient(to right, ${parseContainerBackgroundGradient(layout, {
    lighthenOffset,
  }).join(', ')})`;
}

// function parseContainerBackgroundColor(layout, alpha = 1) {
//     const color = tinycolor(layout?.background?.container_color);
//     color?.setAlpha(alpha);

//     return color.toRgbString();
// }

function parseSelectedColor(layout, alpha = 1) {
  // let color = tinycolor(layout?.background?.container_color);
  // color = color?.brighten(12);
  // color?.setAlpha(alpha);

  // return color.toRgbString();
  return parseDefaultTextColor(layout, 0.25 * alpha);
}

function parseDefaultTextColor(layout, alpha = 1) {
  const color = tinycolor(layout?.text?.default_color);
  color?.setAlpha(alpha);

  return color.toRgbString();
}

function parseDefaultBackgroundColor(layout) {
  return layout
    ? tinycolor(layout?.background?.default_color).toRgbString()
    : layoutDefaults.primaryColor;
}

function parseDefaultBackgroundShade(layout, shade = 0) {
  const color = layout
    ? tinycolor(layout?.background?.default_color)
    : tinycolor(layoutDefaults.primaryColor);
  return color.darken(shade).toString();
}

function parseLayoutBoxShadow(layout, isEmpty) {
  return (
    !isEmpty && `0px 0px 12px ${parseContainerBackgroundShade(layout, 15)}`
  );
}

export {
  parseContainerBackgroundShade,
  parseContainerBackgroundGradient,
  parseDividerBackgroundGradient,
  parseSelectedColor,
  parseContainerBackgroundImage,
  parseDefaultTextColor,
  // parseContainerBackgroundColor,
  parseDefaultBackgroundColor,
  parseDefaultBackgroundShade,
  parseLayoutBoxShadow,
};
